// CORE
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { featureFlagsSelectors } from 'companion-app-components/flux/feature-flags';
import { transactionsActions } from 'companion-app-components/flux/transactions';

// MUI

// DATA
import * as transactionSelectors from 'data/transactions/selectors';

// CUSTOM
import useQDialogs from 'components/QDialogs/useQDialogs';

import * as qdata from './core';


function useQData(wrapperId, robotMode) {

  const txnsByAccountId = useSelector(transactionSelectors.getTransactionsByAccountId);
  const featureFlags = useSelector(featureFlagsSelectors.getFeatureFlags);

  const dispatch = useDispatch();
  const createTransaction = (payload, meta) => dispatch(transactionsActions.createTransaction(payload, meta));
  const updateTransaction = (payload, meta) => dispatch(transactionsActions.updateTransaction(payload, meta));
  const batchTransactions = (payload, meta) => dispatch(transactionsActions.batchTransactions(payload, meta));
  const deleteTransaction = (payload, meta) => dispatch(transactionsActions.deleteTransaction(payload, meta));
  const performTransactionAction = (payload, meta) => dispatch(transactionsActions.performTransactionAction(payload, meta));
  const genericDispatch = (action) => dispatch(action);

  const { dialogAlert } = useQDialogs();

  const forwardProps = {
    wrapperId,
    robotMode,
    createTransaction,
    deleteTransaction,
    updateTransaction,
    batchTransactions,
    performTransactionAction,
    genericDispatch,
    featureFlags,
    txnsByAccountId,
    dialogAlert,
  };

  const QDperformTransactionAction = (action) => qdata.performTransactionAction(action, forwardProps);
  const QDunMatchTransaction = (txn) => qdata.unMatchTransaction(txn, forwardProps);
  const QDmatchTransactions = (txns) => qdata.matchTransactions(txns, forwardProps);
  const QDdeleteTransactions = (txns) => qdata.deleteTransactions(txns, forwardProps);
  const QDsaveTransactions = (txns, cb) => qdata.saveTransactions(txns, cb, forwardProps);
  const QDsetBalanceAdjust = (accountId, date, amount) => qdata.setBalanceAdjust(accountId, date, amount, forwardProps);

  return {
    qDataSaveTransactions: QDsaveTransactions,
    qDataDeleteTransactions: QDdeleteTransactions,
    qDataMatchTransactions: QDmatchTransactions,
    qDataUnMatchTransaction: QDunMatchTransaction,
    qDataPerformTransactionAction: QDperformTransactionAction,
    qDataSetBalanceAdjust: QDsetBalanceAdjust,
  };
}

useQData.propTypes = {
  wrapperId: PropTypes.string,
  robotMode: PropTypes.bool,
};
useQData.defaultProps = {
  robotMode: false,
};

export default useQData;
